import { Box, HStack, Text } from '@chakra-ui/react';
import { CONTACTS } from '../../../constants/contacts';
import { Link } from 'react-router-dom';
import { appColors } from '../../../constants/theme';
import { t } from '../../../locales/locales';

const Contacts = () => {
  return (
    <Box marginTop={4}>
      <Text fontSize={12} fontWeight={600} color="white" textAlign={'center'}>
        {t('contactMe')}
      </Text>
      <HStack
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
        }}
      >
        {CONTACTS?.map((contact) => (
          <Link key={contact.navigate} to={contact.navigate}>
            <Box
              _hover={{
                transform: 'scale(1.1)',
                color: appColors.primary,
                filter: `drop-shadow(0 0 6px ${appColors.primary})`,
              }}
              alignItems="center"
              justifyContent="center"
            >
              <contact.icon size={contact?.size} color={'white'} />
            </Box>
          </Link>
        ))}
      </HStack>
    </Box>
  );
};

export default Contacts;
